import type { RouteRecordRaw } from "vue-router"
import { routerConfig } from "@/router/config"
import { registerNavigationGuard } from "@/router/guard"
import { createRouter } from "vue-router"

const Layouts = () => import("@/layouts/index.vue")

/**
 * @name 项目路由
 * @description 实际项目所设置的路由
 */
const staticProductRoutes: RouteRecordRaw[] = [
  {
    path: "/lamp",
    redirect: "/lamp/lamp_list",
    component: Layouts,
    meta: {
      title: "Lamp",
      roles: ["Lamp"]
    },
    children: [
      {
        path: "/lamp_list",
        name: "Lamp_list",
        meta: {
          title: "Lamp",
          svgIcon: "lamp"
        },
        component: () => import("@/pages/actions/lamp/index.vue")
      }
    ]
  },
  {
    path: "/central", //集中控制
    redirect: "/central/central_list",
    component: Layouts,
    meta: {
      title: "Central",
      roles: ["Central"]
    },
    children: [
      {
        path: "/central_list",
        name: "Central_list",
        meta: {
          title: "Central",
          svgIcon: "music"
        },
        component: () => import("@/pages/actions/Central/index.vue")
      }
    ]
  },
  {
    path: "/musice",
    redirect: "/musice/musice_list",
    component: Layouts,
    meta: {
      title: "Music",
      roles: ["Music"]
    },
    children: [
      {
        path: "/musice_list",
        name: "Musice_list",
        meta: {
          title: "Music",
          svgIcon: "music"
        },
        component: () => import("@/pages/actions/musice/index.vue")
      }
    ]
  },
  {
    path: "/jk",
    redirect: "/jk/jk_list",
    component: Layouts,
    meta: {
      title: "Jk",
      roles: ["Camera"]
    },
    children: [
      {
        path: "/jk_list",
        name: "Jk_list",
        meta: {
          title: "Jk",
          svgIcon: "jk"
        },
        component: () => import("@/pages/actions/jk/index.vue")
      }
    ]
  },
  {
    path: "/led",
    redirect: "/led/led_list",
    component: Layouts,
    meta: {
      svgIcon: "LED",
      title: "LED",
      roles: ["Screen"]
    },
    children: [
      {
        path: "/led_list",
        name: "Led_list",
        meta: {
          title: "LED"
        },
        component: () => import("@/pages/actions/led/index.vue")
      },
      {
        path: "/led_file",
        name: "Led_file",
        meta: {
          title: "Led_file"
        },
        component: () => import("@/pages/actions/led/file.vue")
      },
      {
        path: "/led_program",
        name: "Led_program",
        meta: {
          title: "Led_program"
        },
        component: () => import("@/pages/actions/led/program/program.vue")
      }
    ]
  },
  {
    path: "/alart",
    redirect: "/alart/alart_list",
    component: Layouts,
    meta: {
      title: "Alart",
      roles: ["Alarm"]
    },
    children: [
      {
        path: "/alart_list",
        name: "Alart_list",
        meta: {
          title: "Alart",
          svgIcon: "alart"
        },
        component: () => import("@/pages/actions/alart/index.vue")
      }
    ]
  },
  {
    path: "/hj",
    redirect: "/hj/hj_list",
    component: Layouts,
    meta: {
      title: "Hj",
      roles: ["Environment"]
    },
    children: [
      {
        path: "/hj_list",
        name: "Hj_list",
        meta: {
          title: "Hj",
          svgIcon: "hj"
        },
        component: () => import("@/pages/actions/environment/index.vue")
      }
    ]
  },
  // {
  //   path: "/solar",
  //   redirect: "/solar/solar_list",
  //   component: Layouts,
  //   meta: {
  //     title: "Solar",
  //     roles: ["Solar"]
  //   },
  //   children: [
  //     {
  //       path: "solar_list",
  //       name: "solar_list",
  //       meta: {
  //         title: "Solar",
  //         elIcon: "Sunny"
  //       },
  //       component: () => import("@/pages/actions/solar/index.vue")
  //     },
  //     {
  //       path: "solar_main",
  //       name: "solar_main",
  //       meta: {
  //         title: "Solar",
  //         hidden: true
  //       },
  //       component: () => import("@/pages/actions/solar/main.vue")
  //     }
  //   ]
  // },
  {
    path: "/user",
    redirect: "/user/user_list",
    component: Layouts,
    meta: {
      title: "Staffing",
      elIcon: "User",
      roles: ["Users", "Roles"]
    },
    children: [
      {
        path: "/user_list",
        name: "User_list",
        meta: {
          title: "User",
          roles: ["Users"]
        },
        component: () => import("@/pages/actions/users/index.vue")
      },
      {
        path: "/user_role",
        name: "User_role",
        meta: {
          title: "Roles",
          roles: ["Roles"]
        },
        component: () => import("@/pages/actions/users/roles.vue")
      }
    ]
  },
  {
    path: "/systeam",
    redirect: "/systeam/systeam_list",
    component: Layouts,
    meta: {
      title: "Systeam_list",
      roles: ["System"]
    },
    children: [
      {
        path: "/systeam_list",
        name: "Systeam_list",
        meta: {
          title: "Systeam_list",
          elIcon: "Setting"
        },
        component: () => import("@/pages/actions/systeam/index.vue")
      }
    ]
  },
  {
    path: "/Screen_board",
    name: "Screen_board",
    component: () => import("@/common/pages/Screen_board.vue"),
    meta: {
      title: "Date_big_Screen",
      elIcon: "PieChart",
      breadcrumb: false
    }
  }
]
// const userAgent = navigator.userAgent || navigator.vendor || window.opera

// if (userAgent === "QCefViewTest") {
//   staticProductRoutes.push({
//     path: "/systeam2",
//     redirect: "/systeam2/systeam_set",
//     component: Layouts,
//     meta: {
//       title: "Systemsettings",
//       roles: ["System"]
//     },
//     children: [
//       {
//         path: "/systeam_set",
//         name: "systeam_set",
//         meta: {
//           title: "Systemsettings",
//           elIcon: "Setting"
//         },
//         component: () => import("@/pages/actions/systeam/set.vue")
//       }
//     ]
//   })
// }

/**
 * @name 常驻路由
 * @description 除了 redirect/403/404/login 等隐藏页面，其他页面建议设置唯一的 Name 属性
 */
export const constantRoutes: RouteRecordRaw[] = [
  {
    path: "/redirect",
    component: Layouts,
    meta: {
      hidden: true
    },
    children: [
      {
        path: ":path(.*)",
        component: () => import("@/pages/redirect/index.vue")
      }
    ]
  },
  {
    path: "/403",
    component: () => import("@/pages/error/403.vue"),
    meta: {
      hidden: true
    }
  },
  {
    path: "/404",
    component: () => import("@/pages/error/404.vue"),
    meta: {
      hidden: true
    },
    // Aliases for the record 记录的别名
    alias: "/:pathMatch(.*)*"
  },
  // 登录
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login/index.vue"),
    meta: {
      hidden: true
    }
  },
  // 授权页面
  {
    path: "/authorize",
    name: "authorize",
    component: () => import("@/pages/authorize/index.vue"),
    meta: {
      hidden: true
    }
  },
  {
    path: "/",
    component: Layouts,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        component: () => import("@/pages/dashboard/index.vue"),
        name: "Dashboard",
        meta: {
          title: "Home",
          svgIcon: "dashboard",
          affix: true
        }
      }
    ]
  },
  {
    path: "/user",
    component: Layouts,
    redirect: "/user_center",
    meta: {
      hidden: true
    },
    children: [
      {
        path: "user_center",
        component: () => import("@/pages/User/index.vue"),
        name: "user_center",
        meta: {
          title: "Usercenter",
          svgIcon: "dashboard",
          hidden: true
        }
      }
    ]
  }
]

/**
 * @name 动态路由
 * @description 用来放置有权限 (Roles 属性) 的路由
 * @description 必须带有唯一的 Name 属性
 */
export const dynamicRoutes: RouteRecordRaw[] = [
  ...staticProductRoutes
]

/** 路由实例 */
export const router = createRouter({
  history: routerConfig.history,
  routes: constantRoutes
})

/** 重置路由 */
export function resetRouter() {
  try {
    // 注意：所有动态路由路由必须带有 Name 属性，否则可能会不能完全重置干净
    router.getRoutes().forEach((route) => {
      const { name, meta } = route
      if (name && meta.roles?.length) {
        router.hasRoute(name) && router.removeRoute(name)
      }
    })
  } catch {
    // 强制刷新浏览器也行，只是交互体验不是很好
    location.reload()
  }
}

// 注册路由导航守卫
registerNavigationGuard(router)
